/**
 * EverythingJetSki — AI Mechanic
 * Chat UI, required YMM dropdowns, backend calls, product cards, AJAX cart,
 * and optional contact capture for shop follow-up.
 * Config comes from window.EJS_DIAG_CONFIG (set in the liquid snippet).
 * Dropdown data comes from window.EJS_YMM_DATA (ai-diag-ymm-data.js).
 */
(function () {
  'use strict';

  var CFG = window.EJS_DIAG_CONFIG || {};
  var API = CFG.api || '';
  var CONTACT_API = CFG.contactApi || '';
  var PHONE = CFG.phone || '516-765-1861';
  var CUSTOMER = CFG.customer || null; // logged-in Shopify customer, if any
  var GREETING =
    // "Ai" not "AI" — capital I is indistinguishable from lowercase l here.
    "Hi! I'm the EverythingJetSki Ai Mechanic. Pick your machine above, then " +
    "describe what's happening — a noise, a warning light, won't start, anything — and " +
    "I'll help you figure out the problem and find the right parts.";
  var ERROR_MSG =
    "Sorry — something went wrong on my end. Please try again in a minute, or call us at " + PHONE + '.';
  var STORE_KEY = 'ejs_diag_history_v1';
  var YMM_KEY = 'ejs_diag_ymm_v1';
  var SESSION_KEY = 'ejs_diag_session_v1';
  var CONTACT_KEY = 'ejs_diag_contact_v1';

  var fab, panel, messagesEl, form, input, sendBtn;
  var selYear, selMake, selModel;
  var history = []; // [{role, content, products?}]
  var ymm = null;   // {year, make, model}
  var busy = false;
  var sessionId = null;
  var contactState = null; // null | 'saved' | 'dismissed'
  // A question asked from the header search bar before a machine was picked.
  // Held here and sent automatically once Year/Make/Model are set, so the
  // customer never has to retype what they already told us.
  var pendingPrefill = null;

  // One id per conversation so every turn lands in a single log record.
  function getSessionId() {
    if (sessionId) return sessionId;
    try {
      sessionId = sessionStorage.getItem(SESSION_KEY);
    } catch (e) {}
    if (!sessionId) {
      sessionId =
        'ejs' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      try { sessionStorage.setItem(SESSION_KEY, sessionId); } catch (e) {}
    }
    return sessionId;
  }

  // ── helpers ───────────────────────────────────────────────────────
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function saveState() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(history));
      sessionStorage.setItem(YMM_KEY, JSON.stringify(ymm));
    } catch (e) {}
  }
  function loadState() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (raw) history = JSON.parse(raw) || [];
      var y = sessionStorage.getItem(YMM_KEY);
      if (y) ymm = JSON.parse(y);
    } catch (e) { history = []; ymm = null; }
  }

  function scrollDown() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ── YMM dropdowns — live from Typesense (single source of truth) ──
  // The backend endpoint serves the year/make/model tree built from the
  // Typesense fitments facet; the bundled asset is only an emergency fallback.
  function ymmData() {
    return window.EJS_YMM_DATA || {};
  }

  function loadYmmData(done) {
    if (window.EJS_YMM_DATA) return done();
    var url = String(API).replace(/\/api\/diagnostic-chat.*$/, '/api/diagnostic-ymm');
    var fallback = function () {
      window.EJS_YMM_DATA = window.EJS_YMM_DATA_FALLBACK || {};
      done();
    };
    if (!url || url === API) return fallback();
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { window.EJS_YMM_DATA = d; done(); })
      .catch(fallback);
  }

  function fillSelect(sel, values, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + '</option>';
    values.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v;
      o.textContent = v;
      sel.appendChild(o);
    });
  }

  function initYmmBar() {
    var data = ymmData();
    var years = Object.keys(data).sort(function (a, b) { return b - a; });
    fillSelect(selYear, years, 'Year');
    selMake.disabled = true;
    selModel.disabled = true;
    fillSelect(selMake, [], 'Make');
    fillSelect(selModel, [], 'Model');

    selYear.addEventListener('change', function () {
      var makes = Object.keys(data[selYear.value] || {});
      fillSelect(selMake, makes, 'Make');
      selMake.disabled = !makes.length;
      fillSelect(selModel, [], 'Model');
      selModel.disabled = true;
      onYmmChange();
    });
    selMake.addEventListener('change', function () {
      var models = (data[selYear.value] || {})[selMake.value] || [];
      fillSelect(selModel, models, 'Model');
      selModel.disabled = !models.length;
      onYmmChange();
    });
    selModel.addEventListener('change', onYmmChange);

    // restore previous selection
    if (ymm && data[ymm.year]) {
      selYear.value = ymm.year;
      var makes = Object.keys(data[ymm.year] || {});
      fillSelect(selMake, makes, 'Make');
      selMake.disabled = false;
      selMake.value = ymm.make;
      var models = (data[ymm.year] || {})[ymm.make] || [];
      fillSelect(selModel, models, 'Model');
      selModel.disabled = false;
      selModel.value = ymm.model;
    }
    onYmmChange();
  }

  function onYmmChange() {
    if (selYear.value && selMake.value && selModel.value) {
      ymm = { year: selYear.value, make: selMake.value, model: selModel.value };
    } else {
      ymm = null;
    }
    saveState();
    updateGate();

    // They asked something from the header before picking a machine — now
    // that we know the machine, ask it for them.
    if (ymm && pendingPrefill && !busy) {
      var held = pendingPrefill;
      pendingPrefill = null;
      send(held);
    }
  }

  function updateGate() {
    var ok = !!ymm;
    input.disabled = !ok || busy;
    sendBtn.disabled = !ok || busy;
    input.placeholder = ok
      ? "Describe what's happening with your machine…"
      : 'Select year, make & model above to start';
  }

  // External setter — used by the homepage search bar section
  function setYMM(y) {
    if (!y || !y.year || !y.make || !y.model) return;
    var data = ymmData();
    if (!data[y.year] || !(data[y.year][y.make] || []).length) return;
    selYear.value = y.year;
    fillSelect(selMake, Object.keys(data[y.year]), 'Make');
    selMake.disabled = false;
    selMake.value = y.make;
    fillSelect(selModel, data[y.year][y.make] || [], 'Model');
    selModel.disabled = false;
    selModel.value = y.model;
    onYmmChange();
  }

  // ── rendering ─────────────────────────────────────────────────────
  function renderMessage(msg) {
    var div = document.createElement('div');
    div.className = 'ejs-diag-msg ' + (msg.role === 'user' ? 'user' : 'bot');
    div.textContent = msg.content;
    messagesEl.appendChild(div);
    if (msg.products && msg.products.length) renderProducts(msg.products);
  }

  function renderProducts(products) {
    var wrap = document.createElement('div');
    wrap.className = 'ejs-diag-products';

    products.forEach(function (p) {
      var card = document.createElement('div');
      card.className = 'ejs-diag-card';

      var img = p.image
        ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">'
        : '<div class="ejs-diag-card-noimg">⚙</div>';

      card.innerHTML =
        img +
        '<div class="ejs-diag-card-info">' +
        '<a href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(p.title) + '</a>' +
        '<div class="ejs-diag-card-price">$' + esc(p.price) +
        (p.available ? '' : ' <span class="ejs-diag-card-oos">Out of stock</span>') +
        '</div></div>';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ejs-diag-add';
      btn.textContent = 'Add to Cart';
      if (!p.available) btn.disabled = true;
      btn.addEventListener('click', function () { addToCart([p], btn); });
      card.appendChild(btn);
      wrap.appendChild(card);
    });

    // Liability notice, pinned to the parts list rather than only the footer —
    // this is the point where the customer is about to spend money, and the
    // catalog search can return close-but-wrong matches (see the note below).
    var note = document.createElement('p');
    note.className = 'ejs-diag-disclaimer';
    note.textContent =
      'Suggestions based on what you described — not a confirmed diagnosis. ' +
      'Please verify fitment for your exact machine before ordering. ' +
      'EverythingJetSki is not responsible for parts ordered in error. ' +
      'Not sure? Call ' + PHONE + '.';
    wrap.appendChild(note);

    // NOTE — "Add All" was removed deliberately (Thomas, 2026-07-26).
    //
    // The catalog search returns close-but-wrong matches when it has no exact
    // hit, and the mechanic disclaims those in prose ("the oil pump kits that
    // came up are NOT what you want — ignore those") while still returning
    // them in products[]. A bulk button reads that whole list as endorsed, so
    // one click loaded $465.78 of explicitly-disclaimed parts into the cart —
    // reproduced 3/3 against the live backend.
    //
    // Per-part "Add to Cart" stays: it forces the customer past each card, next
    // to the sentence telling them which ones to skip. Do NOT reinstate a bulk
    // add until products[] is gated to only what the mechanic actually endorses.

    messagesEl.appendChild(wrap);
  }

  // ── Contact capture ───────────────────────────────────────────────────
  // Shown once, only after the customer has actually received a diagnosis with
  // parts, and never to someone already logged in (we have them already).
  // Honest framing: we store it so a tech can follow up — we don't promise an
  // automated email we don't send.
  function contactAlreadyHandled() {
    if (contactState) return true;
    if (CUSTOMER && (CUSTOMER.email || CUSTOMER.id)) return true;
    try {
      var v = sessionStorage.getItem(CONTACT_KEY);
      if (v) { contactState = v; return true; }
    } catch (e) {}
    return false;
  }

  function maybeOfferContact() {
    if (contactAlreadyHandled()) return;
    if (!CONTACT_API) return;
    if (document.getElementById('ejs-diag-contact')) return; // already on screen

    var box = document.createElement('div');
    box.className = 'ejs-diag-contact';
    box.id = 'ejs-diag-contact';
    box.innerHTML =
      '<button type="button" class="ejs-diag-contact-x" aria-label="No thanks">&times;</button>' +
      '<div class="ejs-diag-contact-title">Want one of our techs to follow up?</div>' +
      '<div class="ejs-diag-contact-sub">We’ll save this diagnosis with your machine so we can help you finish the job. Optional.</div>' +
      '<div class="ejs-diag-contact-row">' +
      '<input type="text" class="ejs-diag-contact-name" placeholder="Name (optional)" autocomplete="name" maxlength="80">' +
      '<input type="email" class="ejs-diag-contact-email" placeholder="Email" autocomplete="email" maxlength="120" required>' +
      '<button type="button" class="ejs-diag-contact-go">Send</button>' +
      '</div>';

    box.querySelector('.ejs-diag-contact-x').addEventListener('click', function () {
      contactState = 'dismissed';
      try { sessionStorage.setItem(CONTACT_KEY, 'dismissed'); } catch (e) {}
      box.remove();
    });
    box.querySelector('.ejs-diag-contact-go').addEventListener('click', function () {
      submitContact(box);
    });
    box.querySelector('.ejs-diag-contact-email').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitContact(box); }
    });

    messagesEl.appendChild(box);
    scrollDown();
  }

  function submitContact(box) {
    var nameEl = box.querySelector('.ejs-diag-contact-name');
    var emailEl = box.querySelector('.ejs-diag-contact-email');
    var goBtn = box.querySelector('.ejs-diag-contact-go');
    var email = (emailEl.value || '').trim();
    if (!/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(email)) {
      emailEl.classList.add('ejs-diag-contact-bad');
      emailEl.focus();
      return;
    }
    emailEl.classList.remove('ejs-diag-contact-bad');
    goBtn.disabled = true;
    goBtn.textContent = '…';

    fetch(CONTACT_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: getSessionId(),
        name: (nameEl.value || '').trim(),
        email: email,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.ok) throw new Error('save failed');
        contactState = 'saved';
        try { sessionStorage.setItem(CONTACT_KEY, 'saved'); } catch (e) {}
        box.innerHTML =
          '<div class="ejs-diag-contact-done">✓ Thanks — we’ve got it. ' +
          'One of our techs will follow up. Need us sooner? ' +
          '<a href="tel:+15167651861">' + PHONE + '</a></div>';
      })
      .catch(function () {
        goBtn.disabled = false;
        goBtn.textContent = 'Send';
        emailEl.classList.add('ejs-diag-contact-bad');
      });
  }

  function showTyping() {
    var t = document.createElement('div');
    t.className = 'ejs-diag-typing';
    t.id = 'ejs-diag-typing';
    t.innerHTML = '<i></i><i></i><i></i>';
    messagesEl.appendChild(t);
    scrollDown();
  }
  function hideTyping() {
    var t = document.getElementById('ejs-diag-typing');
    if (t) t.remove();
  }

  function renderAll() {
    messagesEl.innerHTML = '';
    renderMessage({ role: 'assistant', content: GREETING });
    history.forEach(renderMessage);
    scrollDown();
  }

  // ── cart ──────────────────────────────────────────────────────────
  function numericVariantId(gid) {
    var m = String(gid).match(/(\d+)$/);
    return m ? m[1] : null;
  }

  function addToCart(products, btn) {
    var items = products
      .map(function (p) { return { id: numericVariantId(p.variantId), quantity: 1 }; })
      .filter(function (i) { return i.id; });
    if (!items.length) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      })
      .then(function () {
        btn.textContent = '✓ Added';
        btn.classList.add('added');
        refreshCartCount();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        alert('Could not add to cart — please try from the product page, or call ' + PHONE + '.');
      });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      })
      .catch(function () {});
  }

  // ── chat flow ─────────────────────────────────────────────────────
  function send(text) {
    text = (text || '').trim();
    if (!text || busy || !ymm) return;

    history.push({ role: 'user', content: text });
    saveState();
    renderMessage(history[history.length - 1]);
    input.value = '';
    setBusy(true);
    showTyping();

    var payload = {
      ymm: ymm,
      sessionId: getSessionId(),
      messages: history.map(function (m) {
        return { role: m.role, content: m.content };
      }),
    };
    // logged-in customers are attributed silently — never prompted
    if (CUSTOMER && (CUSTOMER.email || CUSTOMER.id)) {
      payload.contact = {
        name: CUSTOMER.name || '',
        email: CUSTOMER.email || '',
        customerId: CUSTOMER.id ? String(CUSTOMER.id) : '',
      };
    }

    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        hideTyping();
        var msg = {
          role: 'assistant',
          content: data.reply || ERROR_MSG,
          products: data.products || [],
        };
        history.push(msg);
        saveState();
        renderMessage(msg);
        // offer follow-up only once they've actually received parts
        if (msg.products && msg.products.length) maybeOfferContact();
        scrollDown();
      })
      .catch(function () {
        hideTyping();
        var msg = { role: 'assistant', content: ERROR_MSG };
        history.push(msg);
        saveState();
        renderMessage(msg);
        scrollDown();
      })
      .then(function () { setBusy(false); });
  }

  function setBusy(b) {
    busy = b;
    updateGate();
    if (!b && ymm) input.focus();
  }

  function openPanel(prefill, presetYmm) {
    panel.hidden = false;
    fab.style.display = 'none';
    if (presetYmm) setYMM(presetYmm);
    renderAll();
    updateGate();
    if (prefill && ymm) {
      send(prefill);
    } else if (prefill) {
      // No machine picked yet. Hold the question rather than losing it —
      // onYmmChange() sends it as soon as they finish the dropdowns.
      pendingPrefill = prefill;
      renderMessage({
        role: 'assistant',
        content: 'Got it — "' + prefill + '"\n\nPick your year, make and model above and ' +
                 "I'll take a look at that right away."
      });
      scrollDown();
      selYear.focus();
    } else if (ymm) {
      input.focus();
    }
  }

  function closePanel() {
    panel.hidden = true;
    fab.style.display = '';
    pendingPrefill = null; // closing means they dropped it — don't fire it later
  }

  function reset() {
    history = [];
    pendingPrefill = null;
    // a fresh conversation gets its own log record + its own follow-up offer
    sessionId = null;
    contactState = null;
    try {
      sessionStorage.removeItem(SESSION_KEY);
      sessionStorage.removeItem(CONTACT_KEY);
    } catch (e) {}
    saveState();
    renderAll();
    if (ymm) input.focus();
  }

  // ── init ──────────────────────────────────────────────────────────
  function init() {
    fab = document.getElementById('ejs-diag-fab');
    panel = document.getElementById('ejs-diag-panel');
    messagesEl = document.getElementById('ejs-diag-messages');
    form = document.getElementById('ejs-diag-form');
    input = document.getElementById('ejs-diag-input');
    sendBtn = document.getElementById('ejs-diag-send');
    selYear = document.getElementById('ejs-diag-year');
    selMake = document.getElementById('ejs-diag-make');
    selModel = document.getElementById('ejs-diag-model');
    if (!fab || !panel) return;

    loadState();
    loadYmmData(initYmmBar);

    fab.addEventListener('click', function () { openPanel(); });
    document.getElementById('ejs-diag-close').addEventListener('click', closePanel);
    document.getElementById('ejs-diag-reset').addEventListener('click', reset);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      send(input.value);
    });

    // Public API — used by the homepage AI search bar section
    window.EJSDiag = { open: openPanel, send: send, close: closePanel, setYMM: setYMM };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
